import { GridFilterOperator } from '@mui/x-data-grid';

import FilterAuthors from '../customFilters/FilterAuthors';

const authorsOperator: GridFilterOperator[] = [
  {
    label: 'is any of',
    value: 'isAnyOf',
    getApplyFilterFn: () => null,
    InputComponent: FilterAuthors
  }
];

export default authorsOperator;
